<template>
    <section v-show="isActive" ref="tabRef" :id="paneId" :data-tab-id="computedId" :aria-hidden="!isActive" class="tabs-component-panel" role="tabpanel" tabindex="-1">
        <slot></slot>
    </section>
</template>

<script setup>
import { computed, ref, watch, inject, onBeforeMount, onBeforeUnmount } from "vue";

const props = defineProps({
    id: String,
    name: String,
    prefix: {
        type: String,
        default: "",
    },
    suffix: {
        type: String,
        default: "",
    },
    isDisabled: {
        type: Boolean,
        default: false,
    },
});

const isActive = ref(false);
const tabsProvider = inject('tabsProvider');
const addTab = inject('addTab');
const updateTab = inject('updateTab');
const deleteTab = inject('deleteTab');

const header = props.prefix + props.name + props.suffix;
const computedId = props.id ? props.id : props.name.toLowerCase().replace(/ /g, "-");
const paneId = computed(() => computedId + "-pane");
const hash = computed(() => "#" + (!props.isDisabled ? computedId : ""));

const tabRef = ref(null);

watch(
    [() => tabsProvider.activeTabHash, () => props],
    ([newActiveTabHash, newProps]) => {
        isActive.value = (hash.value === newActiveTabHash.value);
        updateTab(computedId, {
            name: newProps.name,
            header: newProps.prefix + newProps.name + newProps.suffix,
            isDisabled: newProps.isDisabled,
            hash: hash.value,
            index: tabsProvider.tabs.length,
            computedId: computedId,
            paneId: paneId,
        });
    },
    { deep: true }
);

onBeforeMount(() => {
    addTab({
        name: props.name,
        header: header,
        isDisabled: props.isDisabled,
        hash: hash.value,
        index: tabsProvider.tabs.length,
        computedId: computedId,
        paneId: paneId,
    });
});

onBeforeUnmount(() => {
    deleteTab(computedId);
});

defineExpose({
    header,
    computedId,
    paneId,
    hash,
    isActive
});
</script>
